import React from 'react'

import { Region as CoreRegion, Util } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

const { isText, maxLength, minLength } = Util.validations

export const Region = ({ required = true }) => {
  const { getLabel } = useIntl()

  return (
    <CoreRegion
      label={getLabel('checkout.address.district')}
      errorMessage={getLabel('checkout.address.district.errorMessage')}
      validations={[minLength(2), maxLength(50), isText]}
      required={required}
    />
  )
}
